import React from 'react';

import { useApolloClient } from '@apollo/client';

import { mergeObjects } from '@hrlogics/helper-utils';

import type {
  CognitoGetCurrentUserAuthStatusQuery,
  CognitoGetCurrentUserAuthStatusQueryVariables,
} from 'src/api';

import { useCognito } from '../app';

import { useCurrentUserAuthStatus } from './useCurrentUserAuthStatus';

export const useCurrentUserMfaTotpSetup = () => {
  const apolloClient = useApolloClient();

  const { queryDocument, queryVariables } = useCurrentUserAuthStatus();

  const { mfaValidateSetupUserCode, mfaSetup } = useCognito();

  const setupUserMfaByTotp = React.useCallback(
    async (userCode: string, accessToken: string) => {
      await mfaValidateSetupUserCode({ userCode, accessToken });
      await mfaSetup({ accessToken });

      const options = {
        query: queryDocument,
        variables: queryVariables,
      };

      const queryData = apolloClient.readQuery<
        CognitoGetCurrentUserAuthStatusQuery,
        CognitoGetCurrentUserAuthStatusQueryVariables
      >(options);

      try {
        if (queryData) {
          apolloClient.writeQuery<CognitoGetCurrentUserAuthStatusQuery>({
            ...options,
            data: mergeObjects(queryData, {
              cognitoGetCurrentUserAuthStatus: {
                ...queryData.cognitoGetCurrentUserAuthStatus,
                mfaEnabled: true,
                mfaRequired: false,
              },
            }),
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    [mfaValidateSetupUserCode, mfaSetup, queryDocument, queryVariables, apolloClient],
  );

  return {
    setupUserMfaByTotp,
  };
};
